export default {
  active_orders: {
    title: 'Aktiiviset tilaukset',
  },
  order_history: {
    title: 'Tilaushistoria',
  },
  menu: {
    title: 'Valikko',
  },
  printer_settings: {
    title: 'Tulostimen asetukset',
  },
  order_control: {
    title: 'Tilausten hallinta',
  },
  busy_mode: {
    title_zero: 'Kiireinen tila',
    title_other: 'Kiireinen tila (+{{time}} min)',
  },
  volume: {
    title: 'Äänenvoimakkuus',
  },
  switch_language: {
    title: 'Vaihda kieltä ({{language}})',
  },
  logout: {
    title: 'Kirjaudu ulos',
    description: 'Haluatko varmasti kirjautua ulos?',
    buttons: {
      confirm: 'Kyllä',
      cancel: 'Peruuta',
    },
  },
  test_restaurant: {
    label: 'Testi',
    tooltip: 'Testiravintola: sen tilaukset ovat testejä, eikä siltä koskaan laskuteta.',
  },
};
